window.devMode = false
import angular from 'angular';
import _ from 'lodash/fp';
import config from 'lspConfig';
import restApi from 'app/rest.conf.json';
import 'ngStorage';
import 'angular-aria';
import 'angular-messages';
import 'angular-animate';
import 'angular-gettext';
import 'angular-ui-router';
import 'angular-sanitize';
import 'angular-ckeditor-legacy';
import 'angular-ui-mask';
import 'angular-toastr';
import 'angular-material';
import 'angular-dynamic-locale';
import 'loading-bar';
import 'ui-select';
import 'angular-nvd3';
import moment from 'moment';
import dropdown from 'angular-ui-bootstrap/src/dropdown';
import dialog from 'angular-ui-bootstrap/src/modal';
import ngRedux from 'ng-redux';
import thunk from 'redux-thunk';
import 'api-check';
import { getRetailerId, isStoreProfileSelector, isRetailerDashboardSelector } from 'selectors/index';

// reducers
import reducers from '../reducers.js';

// dependencies
import dependenciesService from 'services/dependencies';

import 'auth/auth-module';
import 'contact/contact-module';
import 'documents/documents-component';
import 'email-notification-templates/email-notification-templates-component';
import 'sms/sms-component';
import 'faq/faq-component';
import 'message/message-component';
import 'privilege-templates/privilege-templates-component';
import 'registration/registration-module';
import 'report-subscriptions/report-subscriptions-module';
import 'retailer-reports/retailer-reports-module';
import 'admin-reports/admin-reports-module';
import 'security/security-module';
import 'store-profiles/store-profiles-component';
import 'manage-inventory/manage-inventory-component';
import 'dashboard/dashboard-module';
import 'user/user-module';
import 'utils/utils-component';
import 'terms-preview/terms-preview-module';
import 'retailer-dashboards/retailer-dashboards-module';
import 'download-report-page/download-report-page-module';
import 'app/app-component';

import './config/errorcodes.conf';
import appLogic from './logic/app';
import sessionLogic from 'auth/logic/session';
import auth from 'auth/logic/auth';
import contact from 'contact/logic/contact';

import emailNotificationTemplates from 'email-notification-templates/logic/email-notification-templates';
import sms from 'sms/logic/sms';
import faq from 'faq/logic/faq';

import privilegeTemplates from 'privilege-templates/logic/privilege-templates';
import registration from 'registration/logic/registration';

import retailerReports from 'retailer-reports/logic/retailer-reports';
import adminReports from 'admin-reports/logic/admin-reports';
import security from 'security/logic/security';

import manageInventory from 'manage-inventory/logic/manage-inventory';
import dashboard from 'dashboard/logic/dashboard';
import user from 'user/logic/user';
import utils from 'utils/logic/utils';





import authValidators from 'auth/validators/action-validators'
import contactValidators from 'contact/validators/action-validators'

import emailNotificationTemplatesValidators from 'email-notification-templates/validators/action-validators'
import smsValidators from 'sms/validators/action-validators'
import faqValidators from 'faq/validators/action-validators'

import privilegeTemplatesValidators from 'privilege-templates/validators/action-validators'
import registrationValidators from 'registration/validators/action-validators'

import retailerReportsValidators from 'retailer-reports/validators/action-validators'
import adminReportsValidators from 'admin-reports/validators/action-validators'
import securityValidators from 'security/validators/action-validators'

import manageInventoryValidators from 'manage-inventory/validators/action-validators'
import dashboardValidators from 'dashboard/validators/action-validators'
import userValidators from 'user/validators/action-validators'
import utilsValidators from 'utils/validators/action-validators'





import ForbiddenComponent from './components/forbidden/forbidden-component';
import { dispatch, checkAccess, checkAccessLazy, checkValidators, checkValidatorsLazy } from 'rw-redux/action-dispatcher';
import validators from './validators/action-validators';
import appHelpers from './app-helpers';
import template from './app.html';
import systemUnavailableTemplate from './views/system-unavailable.html';

import './components/impersonating-bar/impersonating-bar-component';
import './components/side-menu/side-menu-component';
import './components/home/home-component';
import 'utils/datepicker/angular-datepicker';

import NavbarModule from './components/navbar/navbar-module';
import TopMenuModule from './components/top-menu/top-menu-module';

import { applyMenu } from 'auth/actions/session.actions';
import { fetchLotteryContacts } from 'contact/actions/contact.actions';
import { fetchNewLabelStatus } from 'documents/actions/fetch-new-label-status.actions';
import { fetchUnreadMessagesCount } from 'message/actions/unread-count.actions';
import { fetchLotteryTermsDictionary } from 'app/actions/dictionaries/lottery-terms-dictionary.actions';
import { setTheme, restoreTheme } from 'app/actions/theme.actions';
import { clearRetailerDashboards } from 'retailer-dashboards/actions/retailer-dashboards.actions';

@Inject('appFactory', '$state', 'Responsive')
class AppController {
  $onInit() {
    window.addEventListener('unhandledrejection', this.unhandledRejection);
    window.addEventListener('rejectionhandled', this.rejectionHandler);
  }

  $onDestroy() {
    window.removeEventListener('unhandledrejection', this.unhandledRejection);
    window.removeEventListener('rejectionhandled', this.rejectionHandler);
  }

  unhandledRejection(e) {
    e.preventDefault();
  }

  rejectionHandler(e) {
    e.preventDefault();
  }
}

@Inject(
  '$timeout',
  '$sessionStorage',
  '$state',
  'RestWrapperService',
  'gettextCatalog',
  'ErrorService',
  'ErrorNotificationService',
  'AlertService',
  'Notifications',
  '$filter',
  '$ngRedux',
  'tmhDynamicLocale',
)
class AppFactory {
  constructor() {
    Object.assign(this, {
      deps: {
        $timeout: this.$timeout,
        $sessionStorage: this.$sessionStorage,
        $state: this.$state,
        $filter: this.$filter,
        restSrv: this.RestWrapperService,
        gettextCatalog: this.gettextCatalog,
        ErrorService: this.ErrorService,
        ErrorNotificationService: this.ErrorNotificationService,
        AlertService: this.AlertService,
        Notifications: this.Notifications,
        config,
		restApi,
        init: this.init.bind(this),
        initNgServices: this.initNgServices.bind(this),
        checkAndSetMaintenance: appLogic.checkAndSetMaintenance,
        $ngRedux: this.$ngRedux,
      },
      validators,
      uiHelpers: {
        showDialog: this.Notifications.showSimpleDialog.bind(Notifications),
        showComplexDialog: this.Notifications.showComplexDialog.bind(Notifications),
        showAlert: this.Notifications.showAlert.bind(Notifications),
        validateField: appHelpers.validateField.bind(null),
        shouldShowValidation: appHelpers.shouldShowValidation.bind(null),
        printElement: appHelpers.printElement.bind(null),
        saveSession: sessionLogic.saveSession.bind(null, $sessionStorage),
        redirectAfterLogin: appHelpers.redirectAfterLogin.bind(null),
      },
    });

    this.validators = _.merge(this.validators, authValidators);
		this.validators = _.merge(this.validators, contactValidators);
		
this.validators = _.merge(this.validators, emailNotificationTemplatesValidators);
		this.validators = _.merge(this.validators, smsValidators);
		this.validators = _.merge(this.validators, faqValidators);
		
this.validators = _.merge(this.validators, privilegeTemplatesValidators);
		this.validators = _.merge(this.validators, registrationValidators);
		
this.validators = _.merge(this.validators, retailerReportsValidators);
		this.validators = _.merge(this.validators, adminReportsValidators);
		this.validators = _.merge(this.validators, securityValidators);
		
this.validators = _.merge(this.validators, manageInventoryValidators);
		this.validators = _.merge(this.validators, dashboardValidators);
		this.validators = _.merge(this.validators, userValidators);
		this.validators = _.merge(this.validators, utilsValidators);
		



  }

  initNgServices() {
    this.deps.ErrorService.initialize(this.deps.config);
    this.deps.ErrorNotificationService.initialize(this.deps.config);
    this.deps.restSrv.HttpService.resetReauthQueue();
  }

  initActions() {
    this.actions = {
      app: this.bindActions(appLogic, 'app'),
    };

    this.actions['auth'] = this.bindActions(auth, 'auth');
		this.actions['contact'] = this.bindActions(contact, 'contact');
		
this.actions['emailNotificationTemplates'] = this.bindActions(emailNotificationTemplates, 'emailNotificationTemplates');
		this.actions['sms'] = this.bindActions(sms, 'sms');
		this.actions['faq'] = this.bindActions(faq, 'faq');
		
this.actions['privilegeTemplates'] = this.bindActions(privilegeTemplates, 'privilegeTemplates');
		this.actions['registration'] = this.bindActions(registration, 'registration');
		
this.actions['retailerReports'] = this.bindActions(retailerReports, 'retailerReports');
		this.actions['adminReports'] = this.bindActions(adminReports, 'adminReports');
		this.actions['security'] = this.bindActions(security, 'security');
		
this.actions['manageInventory'] = this.bindActions(manageInventory, 'manageInventory');
		this.actions['dashboard'] = this.bindActions(dashboard, 'dashboard');
		this.actions['user'] = this.bindActions(user, 'user');
		this.actions['utils'] = this.bindActions(utils, 'utils');
		



  }

  bindActions(module, moduleName) {
    return Object.keys(module).reduce((reduced, functionName) => {
      if (typeof module[functionName] === 'function') {
        reduced[functionName] = module[functionName].bind(null, this.deps);
      }
      return reduced;
    }, {});
  }

  initModel(moduleLogic) {
    return (moduleLogic.initializeModel || (() => this.model))(this.deps, this.model);
  }

  initData() {
    return this.dispatch('app.loadDictionaries', true).run();
  }

  init() {
    return appLogic
      .loadFeConfig(this.deps)
      .then((newConfig) => {
        this.deps.$ngRedux.dispatch(setTheme());
        this.model = {
          dictionary: {
            statusChangeReasons: {},
          },
          session: {},
        };

        this.deps.config = _.merge(this.deps.config, newConfig);
        this.deps.config.ssnLength = _.get('[0]', this.deps.config.ssnRegex.match(/\d+/));

        this.model = this.initModel(auth);
		this.model = this.initModel(contact);
		
this.model = this.initModel(emailNotificationTemplates);
		this.model = this.initModel(sms);
		this.model = this.initModel(faq);
		
this.model = this.initModel(privilegeTemplates);
		this.model = this.initModel(registration);
		
this.model = this.initModel(retailerReports);
		this.model = this.initModel(adminReports);
		this.model = this.initModel(security);
		
this.model = this.initModel(manageInventory);
		this.model = this.initModel(dashboard);
		this.model = this.initModel(user);
		this.model = this.initModel(utils);
		




        this.model = this.initModel(appLogic);
        this.deps.checkAccess = checkAccess.bind(this, this.validators);
        this.deps.checkAccessLazy = checkAccessLazy.bind(this, this.validators);
        this.deps.checkValidatorsLazy = checkValidatorsLazy.bind(this, this.validators);

        // cg busy promise

        this.busy = Promise.resolve(this.model);
        this.checkValidators = checkValidators.bind(this, this.validators);
        this.checkAccess = checkAccess.bind(this, this.validators);
        this.checkAccessLazy = checkAccessLazy.bind(this, this.validators);
        this.checkValidatorsLazy = checkValidatorsLazy.bind(this, this.validators);
        this.dispatch = dispatch.bind(this, this.deps.$timeout, this.validators);
        this.initNgServices();
        this.initActions();

        this.deps.model = this.model;
        dependenciesService.setDeps(this.deps);

        // TODO - change second auth.initializeSession method to something more intuitive
        return this.dispatch('auth.initializeSession', true)
          .run(this.deps.$sessionStorage.userSession, {})
          .then(() => this.deps.restSrv.list(undefined, restApi.anonymous.privileges.url, null, null, 'anonymous.privileges'))
          .then((template) => template.privileges.reduce((reduced, privilege) => _.set(privilege, privilege, reduced), {}))
          .then((anonymousPrivileges) => {
            this.anonymousPrivileges = this.deps.anonymousPrivileges = anonymousPrivileges;
            return this.dispatch('auth.updateSession', !this.model.session.loggedIn).run({ privileges: this.anonymousPrivileges });
          })
          .then(() => {
            this.$ngRedux.dispatch(changeLocale(this.model.session.locale));
            if (this.model.session.loggedIn) {
              return Promise.all([
                this.$ngRedux.dispatch(fetchNewLabelStatus()),
                this.$ngRedux.dispatch(fetchUnreadMessagesCount()),
                user.loadLotteryLearningLink(this.deps.restSrv, { model: this.model })
              ]);
            }
            return Promise.resolve();
          })
          .then(() => this.$ngRedux.dispatch(fetchLotteryTermsDictionary()))
          .then(() => this.$ngRedux.dispatch(applyMenu()))
          .then(() => this.$ngRedux.dispatch(fetchLotteryContacts(true)))
          .then(() => this.dispatch('app.loadJurisdictionData', true).run())
          .then(() => this.dispatch('contact.loadDefaultContact', true).run())
          .then(() => this.dispatch('auth.getServerTime', true).run())
          .then(() => this.initData())
          .catch((err) => console.error(err));
      })
      .catch((err) => {
        console.error(err);
        throw new Error(err);
      });
  }
}

class AppComponent {
  constructor() {
    this.controller = AppController;
    this.controllerAs = 'appCtrl';
    this.template = template;
    this.bindings = {
      api: '<',
    };
    return this;
  }
}

const PASSWORD_RESET_STATE = 'changePasswd';

import { setCurrentState, setAttemptedRoute, setStoreProfileRetailer, cleartRetailerDashboardType, changeLocale } from 'auth/actions/session.actions';
import { fetchRetailerDetails } from 'utils/actions/utils.actions';


export default angular
  .module('app', [
    // vendor modules
    'ngMessages',
    'ngMaterial',
    'ngAria',
    'ngStorage',
    'gettext',
    'ui.router',
    'ngSanitize',
    'ngMessages',
    'ngAnimate',
    'toastr',
    'ckeditor',
    'impersonating-bar',
    'side-menu',
    NavbarModule.name,
    TopMenuModule.name,
    'home',
    'app-errorcodes',
    'ui.mask',
    '720kb.datepicker',
    'angular-loading-bar',
    dropdown,
    dialog,
    'ui.select',
    'ngRedux',
    'nvd3',
    'tmh.dynamicLocale',
    'auth',
	'contact',
	'documents',
	'email-notification-templates',
	'sms',
	'faq',
	'message',
	'privilege-templates',
	'registration',
	'report-subscriptions',
	'retailer-reports',
	'admin-reports',
	'security',
	'store-profiles',
	'manage-inventory',
	'dashboard',
	'user',
	'utils',
	'terms-preview',
	'retailer-dashboards',
	'download-report-page',
	'app',
	
  ])
  .component('app', new AppComponent())
  .component('forbidden', new ForbiddenComponent())
  .factory('appFactory', (AppFactory.$inject || []).concat((...args) => new AppFactory(...args)))
  .run([
    '$rootScope',
    '$sessionStorage',
    '$state',
    'uiMaskConfig',
    '$timeout',
    '$ngRedux',
    '$uibModalStack',
    'gettextCatalog',
    '$location',
    'tmhDynamicLocale',
    function($rootScope, $sessionStorage, $state, uiMaskConfig, $timeout, $ngRedux, $uibModalStack, gettextCatalog, $location, tmhDynamicLocale) {
      $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options) {
        const privileges = _.get('privileges', $sessionStorage.userSession);
        const passwordExpired =  $sessionStorage.userSession ? _.get('passwordExpired', $sessionStorage.userSession.tokens.jwt) : false;
        const redirectTo = _.get('redirectTo', toState);
        const withoutPerms = _.get('withoutPerms', toState);
        let redirect = !_.get(_.get('name', toState).replace(/(-)/g, '.'), privileges) || redirectTo === PASSWORD_RESET_STATE;

        // hide menu
        angular
          .element(document)
          .find('body')
          .removeClass('is-sidenav-hidden');

        // hide modal
        let modal = $uibModalStack.getTop();
        if (modal) {
          event.preventDefault();
          modal.key.dismiss();
          redirect = false;
        }

        if (passwordExpired !== 'true' && toState.name === 'auth-changePassword') {
          event.preventDefault();
          $state.go('home-view');
        }

        if (redirect && !withoutPerms) {
          const notAttemptedRoutes = [
            'user-logout',
            'system-unavailable',
            'permissions-denied',
            'registration-complete',
            'registration-secondaryUser',
            'registration-primary',
            'registration-chainRegistrationDisabled',
            'registration-confirmation',
            'registration-primaryConfirm'
          ];
          if (!notAttemptedRoutes.includes(toState.name)) {
            $ngRedux.dispatch(setAttemptedRoute(toState.name));
          }
          return redirectTo ? $state.go(redirectTo, $state.get(redirectTo).params) && event.preventDefault() : false;
        }
      });

      $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams, options) {
        $ngRedux.dispatch(setCurrentState(toState.name, fromState.name));
        $state.previous = fromState;
        const state = $ngRedux.getState();
        const { session: { locale, pageTitle } } = state;
        const { config: { applicationName } } = state;
        $rootScope.title = pageTitle ? `${applicationName[locale]} - ${pageTitle}` : applicationName[locale];

        if ($location.$$search.productTheme) $ngRedux.dispatch(restoreTheme());

      });

      uiMaskConfig.clearOnBlur = false;

      if($location.$$search.missing) gettextCatalog.debug = true;
    },
  ])
  .config([
    '$mdAriaProvider',
    '$compileProvider',
    '$urlRouterProvider',
    '$locationProvider',
    '$stateProvider',
    'uiMask.ConfigProvider',
    '$httpProvider',
    '$ngReduxProvider',
    '$ariaProvider',
    'tmhDynamicLocaleProvider',
    function configure($mdAriaProvider, $compileProvider, $urlRouterProvider, $locationProvider, $stateProvider, uiMaskConfigProvider, $httpProvider, $ngReduxProvider, $ariaProvider, tmhDynamicLocaleProvider) {
      $mdAriaProvider.disableWarnings();
      $compileProvider.debugInfoEnabled(location.hostname === 'localhost');
      $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|local|data|http|mailto|tel):/);
      $urlRouterProvider.otherwise('/home');
      $locationProvider.html5Mode(false);
      $locationProvider.hashPrefix('');
      uiMaskConfigProvider.allowInvalidValue(true);

      $ariaProvider.config({
        ariaInvalid: false
      });

      tmhDynamicLocaleProvider.localeLocationPattern('external/angular-i18n/angular-locale_{{locale}}.js');

      const middleware = [thunk];

      const enhancers = [];
      if (window.__REDUX_DEVTOOLS_EXTENSION__) {
        enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
      }

      $ngReduxProvider.createStoreWith(reducers, middleware, enhancers);

      $stateProvider
        .state('arw', {
          template: '<app class="display-block" data-api="$resolve.appApi"></app>',
          abstract: true,
          resolve: {
            appApi: [
              'appFactory',
              '$rootScope',
              '$ngRedux',
              (appFactory, $rootScope, $ngRedux) =>
                appFactory
                  .init()
                  .then(() => {
                    $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams, options) {
                      const state = $ngRedux.getState();
                      const isStoreProfileSaved = isStoreProfileSelector(state);
                      const retailerIdFromSession = getRetailerId(state);
                      const isRetailerDashboards = isRetailerDashboardSelector(state);
                      const retailerNoFromParams = fromParams.retailerNo;
                      const retailerNoToParams = toParams.retailerNo;
                      const isRetailerFromStateDifferentThatRetailerFromSession = (retailerNoToParams * 1) !== retailerIdFromSession;
                      const isStoreProfile = retailerNoToParams && retailerIdFromSession && isRetailerFromStateDifferentThatRetailerFromSession;

                      if (isRetailerDashboards && retailerNoFromParams && !retailerNoToParams) {
                        $ngRedux.dispatch(clearRetailerDashboards());
                        $ngRedux.dispatch(cleartRetailerDashboardType());
                      } else if (isStoreProfile) {
                        $ngRedux.dispatch(fetchRetailerDetails(retailerNoToParams * 1));
                        $ngRedux.dispatch(setStoreProfileRetailer(true));
                      } else if (isStoreProfileSaved && retailerNoFromParams) {
                        $ngRedux.dispatch(fetchRetailerDetails());
                        $ngRedux.dispatch(setStoreProfileRetailer(false));
                      }
                    });

                    return {
                      impersonatingBar : {
                         loginBack: appFactory.dispatch('auth.loginBack', true),
                         redirectAfterLogin: appFactory.uiHelpers.redirectAfterLogin.bind(null, appFactory.deps)
                      },
                      sideMenu: {
                        config: appFactory.deps.config,
                        loginForm: {
                          config: appFactory.deps.config,
                          login: appFactory.dispatch('auth.login', true),
                        },
                      },
                    };
                  })
                  .catch((err) => console.error(err)),
            ],
          },
        })
        .state('permissions-denied', {
          parent: 'arw',
          url: '/forbidden',
          template: '<forbidden class="forbidden layout-fill" model="appCtrl.appFactory.model"></forbidden>',
        })
        .state('system-unavailable', {
          params: {
            hideMenu: true,
          },
          url: '/system-unavailable',
          template: systemUnavailableTemplate,
        });
    },
  ]);

angular.element(document).ready(() => {
  angular.bootstrap(document.documentElement, ['app'], {
    strictDi: true
  });
});



// WEBPACK FOOTER //
// ./src/modules/app/app-component.js